import { useState } from 'react';
import { useGetPolygon } from '@api';
import { TGMapPostcodePolygon, TMergeData } from '@types';

export const useSubPostPolygon = () => {
	const [subPostData, setSubPostData] = useState<null | TMergeData | TMergeData[]>(null);
	const [polygons, setPolygons] = useState<google.maps.LatLngLiteral[][]>([]);
	const [fetchError, setFetchError] = useState();
	const { loadingPolygon, callGetPolygon } = useGetPolygon();

	const extractPolygons = (data: TMergeData[]) => {
		const coordinates = data.flatMap((geojson) => {
			if (geojson.type === 'Polygon') return geojson.coordinates;
			if (geojson.type === 'MultiPolygon') return geojson.coordinates.flat();
			return [];
		});

		const GLatLng: google.maps.LatLngLiteral[][] = coordinates.map((coordArr) => {
			let innerArr: google.maps.LatLngLiteral[] = [];
			coordArr.forEach((coord) => {
				const latLng = new google.maps.MVCArray([{ lat: coord[1], lng: coord[0] }]);
				innerArr = [...innerArr, ...latLng.getArray()];
			});
			return innerArr;
		});

		setPolygons(GLatLng);
		return GLatLng;
	}

	const fetch = async (subPosts: { suburb: string; postcode: string; state?: string }[], avoidCache: boolean = false) => {
		const { suburb, postcode, state } = subPosts[0] ?? {};
		const text = [suburb, state, postcode].filter(Boolean).join(' ');
		const returnData = await callGetPolygon({ params: { text, locality_type: 'POSTCODE' }, avoidCache }).then((response) => {
			if (response) {
				const responseData = response.data.data as unknown as TGMapPostcodePolygon | TGMapPostcodePolygon[];
				const items = Array.isArray(responseData) ? responseData : [responseData];
				const geojsons = items.map((item) => item.geojson).filter(Boolean) as TMergeData[];
				const raw = (geojsons.length === 1 ? geojsons[0] : geojsons) as unknown as TMergeData;
				setSubPostData(raw);
				const polygonData = extractPolygons(geojsons);
				return { raw, polygons: polygonData };
			}
		}).catch((err) => {
			if (err && err.cause) setFetchError(err.cause.response.data);
		});

		return returnData as {
			raw: TMergeData;
			polygons: google.maps.LatLngLiteral[][];
		}
	}

	return {
		fetchSubPostPolygon: fetch,
		loadingPostcodePolygon: loadingPolygon,
		subPostData,
		polygons,
		fetchError
	}
}
